/* eslint-disable prettier/prettier */
/* eslint-disable max-len */
/* eslint-disable no-useless-escape */

export const jsonData = {
  'Asphalt Shingles': {
    'New Construction': {
      'Snow Bracket D - Apex': {
        Steel: {
          '#8 Screws|Roofing Nails': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        Copper: {
          '#8 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      //
      'Snow Bracket F - Apex': {
        'Steel|Copper': {
          '#8 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      //
      'Snow Bracket H - Apex': {
        Steel: {
          '#14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        Copper: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket L': {
        Aluminum: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket S': {
        Steel: {
          'Trusses/Rafters': {
            '16D Galvanized Nails': {
              '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
                'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                  'end',
                label: 'End'
              },
              label: 'Sheathing'
            },
            label: 'Fastener Type'
          },
          label: 'Mount To'
        },
        label: 'Snow Bracket Material'
      },
      label: 'Snow Bracket Type'
    },
    Retrofit: {
      'Snow Bracket H - Apex': {
        Steel: {
          '#14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        Copper: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket L': {
        Aluminum: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      label: 'Snow Bracket Type'
    },
    label: 'Construction Type'
  },
  'Cedar Shingles': {
    'New Construction': {
      'Snow Bracket F - Apex': {
        Steel: {
          '#8 Screws|Roofing Nails': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        Copper: {
          '#8 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      //
      'Snow Bracket D - Apex': {
        'Steel|Copper': {
          '#8 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      //

      'Snow Bracket H - Apex': {
        Steel: {
          '#14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        Copper: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket L': {
        Aluminum: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket S': {
        Steel: {
          'Trusses/Rafters': {
            '16D Galvanized Nails': {
              '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
                'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                  'end',
                label: 'End'
              },
              label: 'Sheathing'
            },
            label: 'Fastener Type'
          },
          label: 'Mount To'
        },
        label: 'Snow Bracket Material'
      },
      label: 'Snow Bracket Type'
    },
    Retrofit: {
      'Snow Bracket H - Apex': {
        Steel: {
          '#14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        Copper: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket L': {
        Aluminum: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      label: 'Snow Bracket Type'
    },
    label: 'Construction Type'
  },
  'Concrete/Clay Tile': {
    Eagle: {
      'Direct to Deck|Horizontal Batten': {
        'Snow Bracket A - Apex': {
          'Steel|Copper': {
            'Ground Snow Load|Roof Pitch / Slope|Vertical Exposure of Product|Horizontal Exposure of Product|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Snow Bracket Material'
        },
        label: 'Snow Bracket Type'
      },
      'Elevated Batten|Counter-Batten/Double-Batten': {
        'Snow Bracket A/CB - Apex': {
          'Steel|Copper': {
            'Ground Snow Load|Roof Pitch / Slope|Vertical Exposure of Product|Horizontal Exposure of Product|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Snow Bracket Material'
        },
        label: 'Snow Bracket Type'
      },
      label: 'Installation Method'
    },
    // 'Monier-Lifetile': {
    //   'Direct to Deck|Horizontal Batten': {
    //     'Snow Bracket A - Apex|Snow Bracket A - Classic|Madera Bracket - Classic': {
    //       'Steel|Copper': {
    //         'Ground Snow Load|Roof Pitch / Slope|Vertical Exposure of Product|Horizontal Exposure of Product|Number of Roofing Squares':
    //           'end',
    //         label: 'End'
    //       },
    //       label: 'Snow Bracket Material'
    //     },
    //     label: 'Snow Bracket Type'
    //   },
    //   'Elevated Batten|Counter-Batten/Double-Batten': {
    //     'Madera Bracket - Classic|Snow Bracket A/CB - Apex|Snow Bracket A/CB - Classic': {
    //       'Steel|Copper': {
    //         'Ground Snow Load|Roof Pitch / Slope|Vertical Exposure of Product|Horizontal Exposure of Product|Number of Roofing Squares':
    //           'end',
    //         label: 'End'
    //       },
    //       label: 'Snow Bracket Material'
    //     },
    //     label: 'Snow Bracket Type'
    //   },
    //   label: 'Installation Method'
    // },
    'Vande Hey-Raleigh': {
      'Direct to Deck|Horizontal Batten': {
        'Snow Bracket B - Apex': {
          'Steel|Copper': {
            'Ground Snow Load|Roof Pitch / Slope|Vertical Exposure of Product|Horizontal Exposure of Product|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Snow Bracket Material'
        },
        label: 'Snow Bracket Type'
      },
      'Elevated Batten|Counter-Batten/Double-Batten': {
        'Snow Bracket B/CB - Apex': {
          'Steel|Copper': {
            'Ground Snow Load|Roof Pitch / Slope|Vertical Exposure of Product|Horizontal Exposure of Product|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Snow Bracket Material'
        },
        label: 'Snow Bracket Type'
      },
      label: 'Installation Method'
    },
    Bartile: {
      'Direct to Deck|Horizontal Batten': {
        'Legendary Bracket - Apex|Snow Bracket B - Apex':
          {
            'Steel|Copper': {
              'Ground Snow Load|Roof Pitch / Slope|Vertical Exposure of Product|Horizontal Exposure of Product|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Snow Bracket Material'
          },
        label: 'Snow Bracket Type'
      },
      'Elevated Batten|Counter-Batten/Double-Batten': {
        'Snow Bracket B/CB - Apex': {
          'Steel|Copper': {
            'Ground Snow Load|Roof Pitch / Slope|Vertical Exposure of Product|Horizontal Exposure of Product|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Snow Bracket Material'
        },
        label: 'Snow Bracket Type'
      },
      label: 'Installation Method'
    },
    Ludowici: {
      'Ludowici-Hook-French - Apex': {
        'Steel|Copper': {
          'Ground Snow Load|Roof Pitch / Slope|Vertical Exposure of Product|Horizontal Exposure of Product|Number of Roofing Squares':
            'end',
          label: 'End'
        },
        label: 'Snow Bracket Material'
      },
      'Ludowici-Deck - Apex|Ludowici-Ext Deck-18\" Spanish - Apex':
        {
          Steel: {
            '#8 Screws|Roofing Nails': {
              '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
                'Ground Snow Load|Roof Pitch / Slope|Vertical Exposure of Product|Horizontal Exposure of Product|Number of Roofing Squares':
                  'end',
                label: 'End'
              },
              label: 'Sheathing'
            },
            label: 'Fastener Type'
          },
          Copper: {
            '#8 Screws': {
              '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
                'Ground Snow Load|Roof Pitch / Slope|Vertical Exposure of Product|Horizontal Exposure of Product|Number of Roofing Squares':
                  'end',
                label: 'End'
              },
              label: 'Sheathing'
            },
            label: 'Fastener Type'
          },
          label: 'Snow Bracket Material'
        },
      label: 'Snow Bracket Type'
    },
    label: 'Manufacturer'
  },
  'Corrugated Metal': {
    'Snow Bracket I (Crest) - Apex|Snow Bracket I (Valley) - Apex':
      {
        Steel: {
          '#14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Horizontal Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
    'Snow Bracket C (Bear)|Snow Bracket C (Moose)|Snow Bracket C (Mushroom)|Snow Bracket C (Tree)':
      {
        Steel: {
          '#14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Horizontal Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
    label: 'Snow Bracket Type'
  },
  'Flat Seam Metal': {
    'New Construction': {
      //
      'Snow Bracket G 9.5 - Apex': {
        'Copper': {
          '#8 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket H - Apex': {
        Steel: {
          '#14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        Copper: {
          '#14 Screws|Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket L': {
        Aluminum: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Universal Guard': {
        Aluminum: {
          '#14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      label: 'Snow Bracket Type'
    },
    Retrofit: {
      'Snow Bracket H - Apex': {
        Steel: {
          '#14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        Copper: {
          '#14 Screws|Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket L': {
        Aluminum: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Universal Guard': {
        Aluminum: {
          '#14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      label: 'Snow Bracket Type'
    },
    label: 'Construction Type'
  },
  'Metal Panel': {
    'Snow Bracket H - Apex': {
      Steel: {
        '#14 Screws': {
          '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
            'Ground Snow Load|Horizontal Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Sheathing'
        },
        label: 'Fastener Type'
      },
      Copper: {
        'Stainless Steel #14 Screws': {
          '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
            'Ground Snow Load|Horizontal Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Sheathing'
        },
        label: 'Fastener Type'
      },
      label: 'Snow Bracket Material'
    },
    'Snow Bracket L': {
      Aluminum: {
        'Stainless Steel #14 Screws': {
          '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
            'Ground Snow Load|Horizontal Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Sheathing'
        },
        label: 'Fastener Type'
      },
      label: 'Snow Bracket Material'
    },
    label: 'Snow Bracket Type'
  },
  'Metal Shingles': {
    'Snow Bracket G 11.5 - Apex|Snow Bracket G 9.5 - Apex':
      {
        Steel: {
          '#8 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        Copper: {
          '#8 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
    'Snow Bracket H - Apex': {
      Steel: {
        '#14 Screws': {
          '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
            'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Sheathing'
        },
        label: 'Fastener Type'
      },
      Copper: {
        'Stainless Steel #14 Screws': {
          '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
            'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Sheathing'
        },
        label: 'Fastener Type'
      },
      label: 'Snow Bracket Material'
    },
    'Snow Bracket J - Apex': {
      'Steel|Copper': {
        '3/16 Screws': {
          '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
            'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Sheathing'
        },
        label: 'Fastener Type'
      },
      label: 'Snow Bracket Material'
    },
    'Snow Bracket L': {
      Aluminum: {
        'Stainless Steel #14 Screws': {
          '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
            'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Sheathing'
        },
        label: 'Fastener Type'
      },
      label: 'Snow Bracket Material'
    },
    label: 'Snow Bracket Type'
  },
  'Simulated Slate': {
    'New Construction': {
      'Snow Bracket F - Apex|Snow Bracket F (Extended) - Apex|Snow Bracket D - Apex':
        {
          Steel: {
            '#8 Screws|Roofing Nails': {
              '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
                'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                  'end',
                label: 'End'
              },
              label: 'Sheathing'
            },
            label: 'Fastener Type'
          },
          Copper: {
            '#8 Screws': {
              '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
                'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                  'end',
                label: 'End'
              },
              label: 'Sheathing'
            },
            label: 'Fastener Type'
          },
          label: 'Snow Bracket Material'
        },
      'Snow Bracket G 9.5 - Apex': {
        Copper: {
          '#8 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket H - Apex': {
        Steel: {
          '#14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        Copper: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket L': {
        Aluminum: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket S': {
        Steel: {
          'Trusses/Rafters': {
            '16D Galvanized Nails': {
              '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
                'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                  'end',
                label: 'End'
              },
              label: 'Sheathing'
            },
            label: 'Fastener Type'
          },
          label: 'Mount To'
        },
        label: 'Snow Bracket Material'
      },
      label: 'Snow Bracket Type'
    },
    Retrofit: {
      'Snow Bracket H - Apex': {
        Steel: {
          '#14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        Copper: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket L': {
        Aluminum: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket G 9.5 - Apex': {
        Copper: {
          '#8 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      label: 'Snow Bracket Type'
    },
    label: 'Construction Type'
  },
  Slate: {
    'New Construction': {
      'Snow Bracket F - Apex|Snow Bracket F (Extended) - Apex':
        {
          Steel: {
            '#8 Screws|Roofing Nails': {
              '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
                'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                  'end',
                label: 'End'
              },
              label: 'Sheathing'
            },
            label: 'Fastener Type'
          },
          Copper: {
            '#8 Screws': {
              '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
                'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                  'end',
                label: 'End'
              },
              label: 'Sheathing'
            },
            label: 'Fastener Type'
          },
          label: 'Snow Bracket Material'
        },
      label: 'Snow Bracket Type'
    },
    Retrofit: {
      'Snow Bracket Slate Hook - Apex': {
        'Steel|Copper': {
          'Tile Hook': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      label: 'Snow Bracket Type'
    },
    label: 'Construction Type'
  },
  'Standing Seam': {
    'Snow Bracket H - Apex': {
      Steel: {
        '#14 Screws': {
          '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
            'Ground Snow Load|Horizontal Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Sheathing'
        },
        label: 'Fastener Type'
      },
      Copper: {
        'Stainless Steel #14 Screws': {
          '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
            'Ground Snow Load|Horizontal Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Sheathing'
        },
        label: 'Fastener Type'
      },
      label: 'Snow Bracket Material'
    },
    //
    'Snow Bracket G 9.5 - Apex': {
      'Copper': {
        '#8 Screws': {
          '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
            'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Sheathing'
        },
        label: 'Fastener Type'
      },
      label: 'Snow Bracket Material'
    },
    //

    'Snow Bracket L': {
      Aluminum: {
        'Stainless Steel #14 Screws': {
          '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
            'Ground Snow Load|Horizontal Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
              'end',
            label: 'End'
          },
          label: 'Sheathing'
        },
        label: 'Fastener Type'
      },
      label: 'Snow Bracket Material'
    },
    label: 'Snow Bracket Type'
  },
  'Wood Shakes': {
    'New Construction': {
      'Snow Bracket F - Apex': {
        Steel: {
          '#8 Screws|Roofing Nails': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        Copper: {
          '#8 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      //
      'Snow Bracket F (Extended) - Apex': {
        'Steel|Copper': {
          '#8 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      //
      'Snow Bracket G 9.5 - Apex': {
        Copper: {
          '#8 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket H - Apex': {
        Steel: {
          '#14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        Copper: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product||Number of Roofing Squares': 'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket L': {
        Aluminum: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket S': {
        Steel: {
          'Trusses/Rafters': {
            '16D Galvanized Nails': {
              '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
                'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                  'end',
                label: 'End'
              },
              label: 'Sheathing'
            },
            label: 'Fastener Type'
          },
          label: 'Mount To'
        },
        label: 'Snow Bracket Material'
      },
      label: 'Snow Bracket Type'
    },
    Retrofit: {
      'Snow Bracket H - Apex': {
        Steel: {
          '#14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        Copper: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket L': {
        Aluminum: {
          'Stainless Steel #14 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      'Snow Bracket G 9.5 - Apex': {
        Copper: {
          '#8 Screws': {
            '7/16 PLY|7/16 OSB|1/2 PLY|1/2 OSB|5/8 PLY|5/8 OSB|3/4 PLY|3/4 OSB': {
              'Ground Snow Load|Vertical Exposure of Product|Roof Pitch / Slope|Number of Roofing Squares':
                'end',
              label: 'End'
            },
            label: 'Sheathing'
          },
          label: 'Fastener Type'
        },
        label: 'Snow Bracket Material'
      },
      label: 'Snow Bracket Type'
    },
    label: 'Construction Type'
  },
  label: 'Roof Type'
};
